/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'userName': {
    width: 36,
    height: 36,
    viewBox: '0 0 36 36',
    data: '<defs/><g id="icon_shoujihao" transform="translate(-41 -657)"><path pid="0" id="矩形_2264" data-name="矩形 2264" class="cls-1" transform="translate(41 657)" d="M0 0h36v36H0z"/><path pid="1" id="icon_shoujihao-2" data-name="icon_shoujihao" class="cls-2" d="M181.061 68.972H164.1a4.511 4.511 0 0 1-4.522-4.5v-27a4.511 4.511 0 0 1 4.522-4.5h16.956a4.511 4.511 0 0 1 4.522 4.5v27a4.511 4.511 0 0 1-4.522 4.5zm2.261-31.5a2.256 2.256 0 0 0-2.261-2.25H164.1a2.256 2.256 0 0 0-2.261 2.25V38.6h21.478v-1.128zm0 3.375h-21.478v17.965h21.478zm0 20.215h-21.478v3.41a2.256 2.256 0 0 0 2.261 2.25h16.956a2.255 2.255 0 0 0 2.261-2.25v-3.41zM172.583 65.6a1.688 1.688 0 1 1 1.695-1.688 1.691 1.691 0 0 1-1.695 1.688zm0 0z" transform="translate(-113.583 624.028)"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/userName.js